import Alpine from "alpinejs";
import DOMFxEvents from "../fx/DOMFxEvents";

Alpine.data("DOMFxEvents", DOMFxEvents);
